import { getScrollbarWidth } from "./helpers.js";
import { StyleCache } from "../css.js";
const styleCache = new StyleCache();
const lockStandardScroll = (args) => {
    const { container } = args;
    const rect = container.getBoundingClientRect();
    const isOverflowing = rect.left + rect.right < window.innerWidth;
    styleCache.set(container, { overflow: "hidden" });
    if (isOverflowing) {
        const scrollBarWidth = getScrollbarWidth();
        styleCache.set(container, { paddingRight: `${scrollBarWidth}px` });
    }
    return () => styleCache.reset();
};
export default lockStandardScroll;
